export default __webpack_public_path__ + "static/media/magazine1.1347407e.png";